import React, { useEffect } from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Stack, Typography } from "@mui/material";

export default function Slogan() {
  const { t } = useTranslation();

  useEffect(() => {
    const title = document.getElementById("title");
    const titleText = title.textContent;
    const titleWords = titleText.split(" ");
    const newTitle = titleWords.map((word) => {
      if (word === "Tijuana" || word === "San" || word === "Diego.") {
        return `<span style="color: #EF60A3; font-weight: 700; font-size: inherit">${word}</span>`;
      }
      return word;
    });
    title.innerHTML = newTitle.join(" ");
  }, []);

  return (
    <Stack direction="column" gap="10px">
      <Typography
        id="title"
        color="primary"
        variant="h5"
        component="h1"
        fontWeight={700}
      >
        {t("slogan.title")}
      </Typography>
      <Typography component="h2" variant="body1" color="secondary" fontWeight={700}>
        {t("slogan.subtitle")}
      </Typography>
      <Typography variant="body2" color="secondary.light" fontWeight={400}>
        {t("slogan.description")}
      </Typography>
    </Stack>
  );
}
